import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { campaigncharttext } from "variables/MBM/campaign";
import { chartsourceData, chartgranularityData, charttypefullData, charttypepointData } from "variables/MBM/lists/campaign";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { adanceddefpagetext } from "variables/alerts";
import { adanceddeffromdaydata, adanceddeftodaydata, adanceddefhourdata } from "variables/lists/alerts";
import IntInput from "components/Input/IntInput";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const ChangeLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function AdvancedDefDialog(props) {
  const { closeModal, granularity, def } = props;

  console.log(def);

  const [changedatashift, setChangedatashift] = useState(def?.changedatashift || false);
  const [datashifthour, setDatashifthour] = useState(def?.datashifthour || "");
  const [datashiftday, setDatashiftday] = useState(def?.datashiftday || "");
  const [datashiftmonth, setDatashiftmonth] = useState(def?.datashiftmonth || "");

  const [changedatatimefiltering, setChangedatatimefiltering] = useState(def?.changedatatimefiltering || false);
  const [fromday, setFromday] = useState(def?.fromday || "");
  const [fromhour, setFromhour] = useState(def?.fromhour || "");
  const [today, setToday] = useState(def?.today || "");
  const [tohour, setTohour] = useState(def?.tohour || "");

  const handleChangedatashiftChange = (event) => {
    setDatashifthour("");
    setDatashiftday("");
    setDatashiftmonth("");
    setChangedatashift(!changedatashift);
  };
  const handleDatashifthourChange = (event) => {
    let hour = event.target.value;
    if (hour < 0)
      hour = 0;
    else if (hour > 24)
      hour = 24;
    setDatashifthour(hour);
  };
  const handleDatashiftdayChange = (event) => {
    let day = event.target.value;
    if (day < 0)
      day = 0;
    else if (day > 1095)
      day = 1095;
    setDatashiftday(day);
  };
  const handleDatashiftmonthChange = (event) => {
    let month = event.target.value;
    if (month < 0)
      month = 0;
    else if (month > 36)
      month = 36;
    setDatashiftmonth(month);
  };

  const handleChangedatatimefilteringChange = (event) => {
    setFromday("");
    setFromhour("");
    setToday("");
    setTohour("");
    setChangedatatimefiltering(!changedatatimefiltering);
  };
  const handleFromdayChange = (event) => {
    setFromday(event.target.value);
  };
  const handleFromhourChange = (event) => {
    setFromhour(event.target.value);
  };
  const handleTodayChange = (event) => {
    setToday(event.target.value);
  };
  const handleTohourChange = (event) => {
    setTohour(event.target.value);
  };

  useEffect(() => {

  }, []);


  console.log(datashifthour);

  const classes = useStyles();



  const handleSubmit = (event) => {
    def.changedatashift = changedatashift;
    def.datashifthour = datashifthour;
    def.datashiftday = datashiftday;
    def.datashiftmonth = datashiftmonth;
    def.changedatatimefiltering = changedatatimefiltering;
    def.fromday = fromday;
    def.fromhour = fromhour;
    def.today = today;
    def.tohour = tohour;

    closeModal();
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{adanceddefpagetext.changedatashift}</ChangeLabel>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={changedatashift}
                    handleSwitchChange={handleChangedatashiftChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <IntInput
                    inputTitle={adanceddefpagetext.datashiftmonth}
                    intInput={datashiftmonth}
                    handleIntInputChange={handleDatashiftmonthChange}
                    disabled={!changedatashift}
                    max={36}
                  />
                </div>
              </GridItem>
              {(granularity === '1h' || granularity === '1d') ?
                <GridItem xs={3} sm={3} md={3} lg={3}>
                  <div>
                    <IntInput
                      inputTitle={adanceddefpagetext.datashiftday}
                      intInput={datashiftday}
                      handleIntInputChange={handleDatashiftdayChange}
                      disabled={!changedatashift}
                      max={1095}
                    />
                  </div>
                </GridItem> : <></>
              }
              {granularity === '1h' ?
                <GridItem xs={3} sm={3} md={3} lg={3}>
                  <div>
                    <IntInput
                      inputTitle={adanceddefpagetext.datashifthour}
                      intInput={datashifthour}
                      handleIntInputChange={handleDatashifthourChange}
                      disabled={!changedatashift}
                      max={24}
                    />
                  </div>
                </GridItem> : <></>
              }
            </GridContainer>
          </GridItem>
          {(granularity === '1h' || granularity === '1d') ?

            <GridItem xs={12} sm={12} md={12} lg={12}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <ChangeLabel>{adanceddefpagetext.changedatatimefiltering}</ChangeLabel>
                </GridItem>
                <GridItem xs={6} sm={6} md={1} lg={1}>
                  <div>
                    <CustomSwitch
                      inputTitle={''}
                      checkedState={changedatatimefiltering}
                      handleSwitchChange={handleChangedatatimefilteringChange}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={11} lg={11}>
                  <GridContainer>
                    <GridItem xs={6} sm={6} md={4} lg={4}>
                      <div>
                        <CustomSelect
                          inputTitle={adanceddefpagetext.fromday}
                          selectValue={fromday}
                          handleSelectValueChange={handleFromdayChange}
                          data={adanceddeffromdaydata}
                          disabled={!changedatatimefiltering}
                        />
                      </div>
                    </GridItem>
                    {granularity === '1h' ?
                      <GridItem xs={6} sm={6} md={2} lg={2}>
                        <div>
                          <CustomSelect
                            inputTitle={adanceddefpagetext.fromhour}
                            selectValue={fromhour}
                            handleSelectValueChange={handleFromhourChange}
                            data={adanceddefhourdata}
                            disabled={!changedatatimefiltering}
                          />
                        </div>
                      </GridItem> : <></>
                    }
                    {
                      (fromday !== 'all' && fromday !== 'weekdays' && fromday !== 'weekenddays') ?

                        <GridItem xs={6} sm={6} md={4} lg={4}>
                          <div>
                            <CustomSelect
                              inputTitle={adanceddefpagetext.today}
                              selectValue={today}
                              handleSelectValueChange={handleTodayChange}
                              data={adanceddeftodaydata}
                              disabled={!changedatatimefiltering}
                            />
                          </div>
                        </GridItem>
                        : <></>
                    }
                    {granularity === '1h' ?
                      <GridItem xs={6} sm={6} md={2} lg={2}>
                        <div>
                          <CustomSelect
                            inputTitle={adanceddefpagetext.tohour}
                            selectValue={tohour}
                            handleSelectValueChange={handleTohourChange}
                            data={adanceddefhourdata}
                            disabled={!changedatatimefiltering}
                          />
                        </div>
                      </GridItem> : <></>
                    }
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </GridItem> : <></>
          }
        </GridContainer>
        <Button
          className={classes.submitButton}
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default AdvancedDefDialog;
